import Marquee from "react-fast-marquee";

const WORDS = [
  "Music Therapy",
  "Energy Healing",
  "Mindfulness",
  "Conscious Living",
  "Sound Baths",
  "Breathwork",
  "Stillness",
  "Renewal",
];

const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="bg-sage/40 border-y border-stone py-8 md:py-10 select-none"
      aria-hidden="true"
    >
      <Marquee speed={34} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic font-light text-forest text-3xl md:text-5xl px-8 md:px-14">
              {w}
            </span>
            <span className="text-gold text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
